import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/** items: [{label, path}] — last item is current page (no link). */
export const Breadcrumbs = ({ items }) => {
  const all = [{ label: "Home", path: "/" }, ...items];
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: all.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.label,
      item: origin + (it.path || ""),
    })),
  };
  return (
    <nav className="text-sm text-slate-500 flex items-center flex-wrap gap-1" aria-label="Breadcrumb" data-testid="breadcrumbs">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      {all.map((it, i) => (
        <React.Fragment key={i}>
          {i > 0 && <ChevronRight size={14} className="text-slate-400" />}
          {i < all.length - 1 && it.path ? (
            <Link to={it.path} className="hover:text-emerald-800">{it.label}</Link>
          ) : (
            <span className="text-slate-700 font-medium">{it.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
